import { ictWorkshopService } from "../service";
import {
  setworkshopsLoading,
  setworkshopsError,
  setworkshopsData,
} from "../slice/workshopSlice";
import {
  setworkshopDetailsLoading,
  settaskSettingData,
  setworkshopDetailsData,
   setworkshopParticipantData,
   setworkshopInventoriesData,
   setresponseListData,
  setworkshopDetailsError,
  setworkshopFollowUpsData,
} from "../slice/workshopDetailSlice";

const handleWorkshopDetailError = (dispatch, response, clearData) => {
  if (response?.data?.error || response?.data?.Error) {
    dispatch(setworkshopDetailsError(response));
    dispatch(clearData({}));
  } else {
    dispatch(clearData(response?.data));
    dispatch(setworkshopDetailsError({}));
  }
};

const getIctWokshopListAsync =
  (page, limit, filter, companyId, t) => async (dispatch) => {
    dispatch(setworkshopsLoading());
    try {
      const response = await ictWorkshopService.getIctWorkshopList(
        page,
        limit,
        filter,
        companyId
      );
      if (response?.data?.error || response?.data?.Error) {
        dispatch(setworkshopsError(response));
        dispatch(setworkshopsData({}));
      } else {
        dispatch(setworkshopsData(response?.data));
        dispatch(setworkshopsError({}));
      }
    } catch (error) {
      dispatch(setworkshopsError(error));
    }
  };

const getIctWokshopTaskSettings =
  (companyId, workshopId, t) => async (dispatch) => {
    dispatch(setworkshopDetailsLoading());
    try {
      const response = await ictWorkshopService.getIctWorkshopTaskSettings(
        companyId,
        workshopId
      );
      handleWorkshopDetailError(dispatch, response, settaskSettingData);
    } catch (error) {
      dispatch(setworkshopDetailsError(error));
    }
  };

const getIctWorkshopParticipantListAsync =
  (page, limit, filter, status, companyId, workshopId, t) =>
  async (dispatch) => {
    dispatch(setworkshopDetailsLoading());
    try {
      const response = await ictWorkshopService.getIctWorkshopParticipantList(
        page,
        limit,
        filter,
        status,
        companyId,
        workshopId
      );
      // eslint-disable-next-line no-undef
      handleWorkshopDetailError(dispatch, response, setworkshopParticipantData);
    } catch (error) {
      dispatch(setworkshopDetailsError(error));
    }
  };

const getIctWorkshopDetailsAsync =
  (companyId, workshopId, t) => async (dispatch) => {
    dispatch(setworkshopDetailsLoading());
    try {
      const response = await ictWorkshopService.getIctWorkshopDetails(
        companyId,
        workshopId
      );
      handleWorkshopDetailError(dispatch, response, setworkshopDetailsData);
    } catch (error) {
      dispatch(setworkshopDetailsError(error));
    }
  };

const getIctWorkshopInventoriesListAsync =
  (page, limit, filter, status, companyId, workshopId, round) =>
  async (dispatch) => {
    dispatch(setworkshopDetailsLoading());
    try {
      const response = await ictWorkshopService.getIctWorkshopInventoriesList(
        page,
        limit,
        filter,
        status,
        companyId,
        workshopId,
        round
      );
      handleWorkshopDetailError(dispatch, response, setworkshopInventoriesData);
    } catch (error) {
      dispatch(setworkshopDetailsError(error));
    }
  };

  const getIctWorkshopEvaluationListAsync =
  (page, limit, filter, status, companyId, workshopId, t) =>
  async (dispatch) => {
    dispatch(setworkshopDetailsLoading());
    try {
      const response = await ictWorkshopService.getIctWorkshopEvaluationList(
        page,
        limit,
        filter,
        status,
        companyId,
        workshopId
      );
      const data = response?.data;
      handleWorkshopDetailError(
        dispatch,
        { data },
        setresponseListData,
      );
    } catch (error) {
      dispatch(setworkshopDetailsError(error));
    }
  };

  // workshop followups
  const getWokshopFollowUpListAsync = (page, limit, filter,companyId,workshopId,t) => async (dispatch) => {
   dispatch(setworkshopDetailsLoading());
  try {
    const response = await ictWorkshopService.getIctFollowUpsList(page, limit, filter,companyId,workshopId);
    if (response?.data?.error || response?.data?.Error) {
      dispatch(setworkshopDetailsError(response));
      dispatch(setworkshopFollowUpsData({}));
    } else {
      dispatch(setworkshopFollowUpsData(response?.data));
      dispatch(setworkshopDetailsError({}));
    }
  } catch (error) {
    dispatch(setworkshopDetailsError(error));
  }
}
const getIctWorkshopFollowupResponseListAsync =
  (page, limit, filter, status, companyId, workshopId, followupId,t) =>
  async (dispatch) => {
    dispatch(setworkshopDetailsLoading());
    try {
      const response = await ictWorkshopService.getIctFollowupResponseList(
        page,
        limit,
        filter,
        status,
        companyId,
        workshopId,
        followupId
      );
      const data = response?.data;
      handleWorkshopDetailError(
        dispatch,
        { data },
        setresponseListData,
      );
    } catch (error) {
      dispatch(setworkshopDetailsError(error));
    }
  };
export const ictWorkshopAction = {
  getIctWokshopListAsync,
  getIctWokshopTaskSettings,
  getIctWorkshopDetailsAsync,
  getIctWorkshopParticipantListAsync,
  getIctWorkshopInventoriesListAsync,
  getIctWorkshopEvaluationListAsync,
  getWokshopFollowUpListAsync,
  getIctWorkshopFollowupResponseListAsync,
};
